export default "__VITE_ASSET__5849ece3__"